/* eslint-disable no-useless-escape */
import React, { useContext, useEffect, FC } from 'react'
import { useHistory, withRouter, RouteComponentProps } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Button } from '@material-ui/core'
import SignupLayout from '../../layout'
import { SignupContext } from '../../context/SignupContextContainer'
import SIGNUP_STEPS from '../../utils/constants'
import { Prospects as ProspectsStore } from '../../stores/prospects'
import AdminTemplate from '../Dashboard/Settings/Templates'
import Spinner from '../Spinner'

interface Props extends RouteComponentProps {
  prospects?: ProspectsStore
}

const Templates: FC<Props> = ({ prospects, match, location }) => {
  const { setSignupStep } = useContext(SignupContext)
  const history = useHistory()

  useEffect(() => {
    prospects?.getUserInfo()
    prospects?.getMasters()
  }, [])

  if (prospects?.isLoading) {
    return <Spinner />
  }

  const skipStep = (): void => {
    setSignupStep(SIGNUP_STEPS.CUSTOMERS)
    history.push('/client/customers')
  }

  const goBack = (): void => {
    setSignupStep(SIGNUP_STEPS.RECON)
    history.push('/client/recon')
  }

  return (
    <SignupLayout page="full-page">
      <AdminTemplate {...{ prospects, history, match, location }} />
      <div className="button-container">
        <Button size="medium" color="primary" className="skipThis" onClick={goBack}>
          Go Back.
        </Button>
        <Button size="medium" color="primary" className="skipThis" onClick={skipStep}>
          Skip this step.
        </Button>
      </div>
    </SignupLayout>
  )
}
export default inject('prospects')(withRouter(observer(Templates)))
